<template>
  <div class="w-full">
    <vs-card
      id="pending-expense-donut-loading"
      class="vs-con-loading__container px-2 widget-card altura"
      style="position: relative"
    >
      <div @click="fullDataTable">
        <vs-row>
          <vs-col>
            <char-header
              :title="$t('pending_expenses_by_client')"
            ></char-header>
          </vs-col>
        </vs-row>
      </div>
      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <vue-apex-charts
              class=""
              type="donut"
              height="250%"
              :options="chartOptions"
              :series="series"
              @dataPointSelection="dataTable"
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import CharHeader from '../components/CharHeader.vue'
//requests
import request from '@/http/requests/dashboard'
//mixins
import loading from '@/mixins/Loading.js'

export default {
  mixins: [loading],
  components: {
    VueApexCharts,
    CharHeader,
  },
  props: {
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartOptions: {
        labels: [],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  formatter: function (w) {
                    let total = 0

                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })
                    return total
                  },
                },
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  fontSize: '30px',
                  formatter(val, w, label) {
                    let total = 0
                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })
                    return val
                  },
                },
              },
            },
          },
        },
        chart: {
          id: 'donut-pending-expense',
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
      },
      series: [],
      colors: [],
      expenseData: [],
      loading: {
        pending_expense_donut: false,
      },
      params: {
        page: 1,
        search: '',
        sortBy: ['Expenses.ReceivedDate'],
        sort: ['DESC'],
        StatusDonutId: 'pendingDonut',
        ClientName: null,
        StatusId: [2],
      },
    }
  },
  computed: {
    isLoading() {
      return this.loading.pending_expense_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('pending-expense-donut-loading')
      } else {
        this.closeLoading('pending-expense-donut-loading')
      }
    },
  },
  mounted() {
    this.getInfo()
    if(this.refresh === true){
      var v = this
      setInterval(function () {
        v.getInfo()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
  methods: {
    getInfo() {
      this.loading.pending_expense_donut = true
      request
        .pendingExpenseData()
        .then((res) => {
          this.expenseData = res.data.data
          this.fillChartData()
          this.loading.pending_expense_donut = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.pending_expense_donut = false
        })
    },

    fillChartData() {
      if (this.expenseData.length == 0) {
        this.series = [1]
        this.chartOptions.labels = ['NO INFO']
        this.colors = ['#626262']
        this.resertDonut()
      } else {
        for (let i = 0; i < this.expenseData.length; i++) {
          this.chartOptions.labels[i] = this.expenseData[i].ClientName
          this.series[i] = parseInt(this.expenseData[i].Amount)
          this.colors[i] = this.expenseData[i].color
        }
        this.resertDonut()
      }
    },
    resertDonut() {
      ApexCharts.exec(
        'donut-pending-expense',
        'updateOptions',
        {
          fill: {
            colors: this.colors,
          },
          labels: this.chartOptions.labels,
          series: this.series,
        },
        (this.loading.pending_expense_donut = false)
      )
    },
    dataTable(event, chartContext, config) {
      if (config != undefined) {
        this.params.ClientName = config.w.config.labels[config.dataPointIndex]
        this.params.StatusId = [2]
      }
      this.$emit('click', { ...this.params })
    },
    fullDataTable() {
      this.params.StatusId = [2]
      this.$emit('click', { ...this.params })
    },
  },
}
</script>
<style>
</style>